import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { BaseAvatarSize } from '../../../shared/components/avatar/base-avatar.component';
import { BaseRolesService } from '../../../core/services/base-roles.service';
import { SharedState } from '../../../_store/reducers/base-shared.reducer';
import { baseAdministrationSelectors, baseSharedSelectors } from '../../../_store';
import { CustomerResponse, PspResponse, UserProfileResponse } from '../../../../api';
import { TabWithPermissionsInterface } from '../../../shared/interfaces/base-tab-with-permissions.interface';

@Component({
  selector: 'base-base-user-menu-sidebar',
  templateUrl: './base-user-menu-sidebar.component.html',
})
export class BaseUserMenuSidebarComponent implements OnInit, OnDestroy {
  @Input({ required: true }) userMenu: TabWithPermissionsInterface[] = [];

  companyData: CustomerResponse | PspResponse;
  userData: UserProfileResponse;
  userFullName: string;
  avatarSizes = BaseAvatarSize;
  userMenuItems: TabWithPermissionsInterface[] = [];
  signDigital: boolean | undefined;

  private destroy$ = new Subject();

  constructor(
    private offcanvasService: NgbOffcanvas,
    private readonly roleService: BaseRolesService,
    private readonly store: Store<SharedState>
  ) {}

  ngOnInit() {
    this.store
      .select(baseSharedSelectors.getProfileData)
      .pipe(
        takeUntil(this.destroy$),
        filter((state) => !!state)
      )
      .subscribe((value) => {
        if (value) {
          this.userData = value;
          this.userFullName = `${value.firstName} ${value.lastName}`;
        }
      });

    if (this.roleService.isPsp()) {
      this.store
        .select(baseAdministrationSelectors.getPspData)
        .pipe(
          takeUntil(this.destroy$),
          filter((state) => !!state),
          map((state) => state.data)
        )
        .subscribe((value) => {
          if (value) {
            this.companyData = value.data;
            this.signDigital = value.data.signDigital;
          }
        });
    } else {
      this.store
        .select(baseAdministrationSelectors.getCustomerDataData)
        .pipe(
          takeUntil(this.destroy$),
          filter((state) => !!state)
        )
        .subscribe((value: CustomerResponse) => {
          if (value) {
            this.companyData = value;
            this.signDigital = value.signDigital;
          }
        });
    }

    this.userMenuItems = this.userMenu?.filter((item) => {
      return this.roleService.isPsp()
        ? !item.permissionsAllowed.length ||
            item.permissionsAllowed.some((permission) => this.roleService.hasPspFeaturePermission(permission))
        : !item.rolesAllowed.length || item.rolesAllowed.some((role) => this.roleService.hasRole(role));
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  closeSidebar(): void {
    this.offcanvasService.dismiss();
  }
}
